import { render, staticRenderFns } from "./RegularRegistration.vue?vue&type=template&id=9d3422ae&"
import script from "./RegularRegistration.vue?vue&type=script&lang=js&"
export * from "./RegularRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RegularRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports